class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => { 
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, this.dataset.associatedIndices, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartFreeShipping extends HTMLElement {
  constructor() {
      super();

      let cartItems = this.fetchCartData();
      let cartArray = [];

      cartItems.then(response => response.json())
      .then(cartJSON => cartJSON.items)
      .then(products => {
        products.forEach(product => {
          if(product.properties._ts_price) {
            console.log("Team Store product in cart.");
            // assigns value of 0 to cartSubtotal
            cartArray.push(0)
          } else {
            // if not Team Store Product, add to array, new cartSubtotal.
            cartArray.push(product.final_line_price);
          }
        })              

        const freeShippingProgressPercentage = document.getElementById('free-shipping-progress-percentage');
        const freeShippingMessage = document.getElementById('free-shipping-message');
        // sum array
        let cartSubtotal = cartArray.reduce((accumulator, current) => accumulator + current, 0);
        // shipping threshold
        const freeShippingQualifier = freeShippingMessage.getAttribute('data-free-shipping-threshold');
        ;
        // cartSubtotal minus threshold
        let cartPriceDifference = parseFloat(((cartSubtotal - freeShippingQualifier) * -1 / 100).toFixed(2));

        const freeShippingProgressDifference = Math.round(100 * cartSubtotal / freeShippingQualifier); 
        // if nothing or only Team Store products
        if (cartSubtotal == null) {
          freeShippingMessage.innerHTML = "Spend " + "$" + cartPriceDifference + " more to get Free Shipping!";
        }
        // free shipping achieved
        else if(cartSubtotal > freeShippingQualifier) {
            freeShippingProgressPercentage.style.width = '100%';
            freeShippingMessage.innerHTML = "Nice! You've got FREE SHIPPING!"
        // amount until free shipping achieved
        } else if (cartSubtotal < freeShippingQualifier) {
            freeShippingProgressPercentage.style.width = freeShippingProgressDifference + "%";
            freeShippingMessage.innerHTML = "Spend " + "$" + cartPriceDifference + " more to get Free Shipping!";
        }
      });               
         
  }
// fetch cart
async fetchCartData() {
    let file = "/cart.js"
    return fetch (file)
  }

}

customElements.define('free-shipping-progress-bar', CartFreeShipping);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      
      if (event.source === 'cart-items') {
        // Refresh Nosto mini cart carousel
        setTimeout(() => {
            Nosto.reloadCart(["mini-cart__nosto-you-may-also-like", "mini-cart__nosto-recently-viewed"]);
        }, 1000);
      return;
    }
    this.onCartUpdate();
    
      // Refresh Nosto mini cart carousel
      setTimeout(() => {
        Nosto.reloadCart(["mini-cart__nosto-you-may-also-like", "mini-cart__nosto-recently-viewed"]);
      }, 1000);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (event.target.dataset.index !== undefined) {
      this.updateQuantity(event.target.dataset.index, event.target.dataset.associatedIndices, event.target.value, document.activeElement.getAttribute('name'), event.target);
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }
  

  updateQuantity(line, associatedIndices, quantity, name, target) {
    const associatedIndexArray = associatedIndices?.split(',')?.filter(index => index != '') ?? [];

    const lineItemsToRemove =  associatedIndexArray.map((associatedIndex) => { 
       
      console.log(document.getElementById(`CartItem-${associatedIndex}`).dataset.itemid)
         return document.getElementById(`CartItem-${associatedIndex}`).dataset.itemid
      })

    // Check associated line item inventories before allowing update
    let maxQty = Infinity;
  
    associatedIndexArray.forEach(associatedIndex => {
      const associatedMaxQty = document.getElementById(`CartItem-${associatedIndex}`)?.dataset.max;
      if (associatedMaxQty && associatedMaxQty !== '0') {
        maxQty = Math.min(associatedMaxQty, maxQty);
      }
    })

    if (quantity > maxQty) {
      if (target) {
        target.value = maxQty;
        target.dataset.currentValue = maxQty.toString();
        alert(window.cartStrings.quantityError.replace('[quantity]', maxQty));
      }
    }

    let attemptedQuantity = Math.min(quantity, maxQty);

    this.enableLoading(line);

    associatedIndexArray.forEach(lineIndex => {
      this.enableLoading(lineIndex);
    })

    const body = JSON.stringify({
      line,
      quantity: attemptedQuantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        let addedQuantity = parsedState?.items?.[line - 1]?.quantity ?? attemptedQuantity;

        if (parsedState.errors) {

          //const lineItemErrorElement = document.getElementById(`CartDrawer-LineItemError-${line}`).querySelector(".cart-item__error-text");
          //lineItemErrorElement.textContent = parsedState.errors;
          alert(parsedState.errors);
          
        }

        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      })
      .then(() => {
        const updates = {};
        lineItemsToRemove.forEach((lineItemId) => {
          updates[lineItemId] = 0; 
        });

        const requestBody = {
          updates,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        })
          .then((response) => response.json())
          .then((cartData) => {    
            this.classList.toggle('is-empty', cartData.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', cartData.item_count === 0);

            this.getSectionsToRender().forEach((section => {
              const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              elementToReplace.innerHTML =
              this.getSectionInnerHTML(cartData.sections[section.section], section.selector);
            }));

            this.updateLiveRegions(cartData.item_count);

            // Focus on the paired line item
            const lineItem =  document.getElementById(`CartItem-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          })
          .catch((error) => {
            // Handle any errors that occur during the fetch request
            console.error(error);
          });
      

        // eslint-disable-next-line no-undef
      //   return Promise.all(associatedFetches)
      //   .then((results) => {
       
      //   console.log('All fetch requests completed:', results);
       
      // })
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus?.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus?.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};